<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PAIE_VIEWER')">
        <slot name="section-paie-viewer">
          <section-paie-viewer ref="PAIE_VIEWER"
                               id="PAIE_VIEWER"
                               :extended="isExtended('PAIE_VIEWER')"
                               :showButton="true"
                               :autoSave="true"
                               :readOnly="readOnly"
                               :moduleId="moduleId"
                               :searchText="searchText"
                               :ressourceHeader="ressource"
                               :fiche="fiche"
                               :paie=selectedPaie
                               :route="route"
                               :attribut="attribut"
                               @extended="setExtended"
                               @fullscreen="setFullscreen"
                               @status="updateStatus"
                               @updated="paieUpdated"
                               @selectItem = "selectItem">
          </section-paie-viewer>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Paie from '@/extend/classes/Paie';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionPaieViewer from '@/custom/sections/SectionPaieViewer.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionPaieViewer,
    FicheHeader,
  },

  props: {
    paie: {
      type: Object as PropType<Paie>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PAIE,
      sections: [
        'PAIE_VIEWER',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PAIE);
    },

    selectedPaie (): Paie {
      return this.paie
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    paieUpdated (paie: Paie) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.paie || this.paie.id < 0) && value == 'PAIE_VIEWER') {
        this.setExtended(new Extended('PAIE_VIEWER', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
